import { render, staticRenderFns } from "./AccessDepot.vue?vue&type=template&id=dc3bb9c4&"
import script from "./AccessDepot.vue?vue&type=script&lang=js&"
export * from "./AccessDepot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports